import { useMemo } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { useGetActivityTypes } from '@/query/queries/report/useGetActivityTypes';
import { OperationTypesSelectModal } from '@/modals/OperationTypesSelectModal';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { useModal } from '@/providers/modal';
import { MenuList, Option, ValueContainer } from './components';
import IconChevron from './icon_chevron.svg';
import s from './index.module.scss';

export const OperationTypeSelect = ({
  selected = [],
  menuPlacement,
  mobile,
  onChange,
}) => {
  const { t } = useTranslation('reports');
  const { openSingleModal } = useModal();
  const { data: activityTypes } = useGetActivityTypes();

  const options = useMemo(() => {
    return activityTypes
      ? Object.keys(activityTypes).map(key => ({
          value: key,
          label: activityTypes[key],
        }))
      : [];
  }, [activityTypes]);

  const values = useMemo(() => {
    return options?.filter(option => selected.includes(option.value));
  }, [selected, options]);

  const onClick = () => {
    openSingleModal(MODAL_IDS.operation_types_select_modal);
  };

  if (mobile)
    return (
      <>
        <div className={s.mobile} onClick={onClick}>
          <span>{t('operation_type_select.all_operations')}</span>
          <img src={IconChevron} alt="icon" width={20} height={20} />
        </div>
        <OperationTypesSelectModal
          selected={selected}
          options={options}
          onChange={onChange}
        />
      </>
    );

  return (
    <div className={s.wrapper}>
      <div className="f-small-accent">
        {t('operation_type_select.operation_type')}
      </div>
      <Select
        value={values}
        onChange={options => onChange(options.map(({ value }) => value))}
        className={s.select}
        classNamePrefix="operation_type"
        name="operation_type"
        isSearchable={false}
        options={options}
        menuPlacement={menuPlacement}
        isMulti
        components={{ ValueContainer, MenuList, Option }}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        placeholder={t('operation_type_select.all_operations')}
      />
    </div>
  );
};
